import type { Result } from '@/shared/types/result'
import type { ApiError } from '@/shared/types/errors'

/**
 * Unwrap a Result, returning the value on success or throwing on error.
 * Standardizes the Result → throw bridge for TanStack Query.
 */
export function unwrapResult<T>(result: Result<T, ApiError>): T {
  if (result.ok) return result.value
  throw new Error(result.error.message)
}
